import {
    getEmployees,
    addEmployee,
    editEmployee,
    deleteEmployee,
    changeStatus
} from "./employees.action";

export {employeesReducer} from "./employees.reducer";
export {watchEmployees} from "./employees.saga";

export const employeesActions = {
    /** Employees */
    getEmployees,
    addEmployee,
    editEmployee,
    deleteEmployee,
    changeStatus
};
